import { styled } from '@mui/material/styles';
import { Paper, Grid, Select } from '@mui/material';

export const DeclineModalBodyWrapperStyled = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '432px',
  padding: theme.spacing(8),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const PrimaryModalButtonsStyled = styled(Grid)(({ theme }) => ({
  marginTop: '16px',
  justifyContent: 'right',
  [theme.breakpoints.down('sm')]: {
    marginTop: 'auto',
  },
}));

export const DeclineReasonSelectStyled = styled(Select)(() => ({
  width: '100%',
  backgroundColor: 'white',
  borderRadius: 5,
  border: '1px solid #D9D9D9',
  marginBottom: '18px',
  '& .MuiSelect-select': {
    paddingLeft: 10,
  },
}));
